<template lang="pug">
.other-user-receive-message-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :filter-included-fields="filterFields"
    :busy="isBusy"
    no-border-collapse
    table-class="basic-table nohead-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません。
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません。

    // セル：メッセージ
    // tableライブラリは使用するが、見た目はtableではないようにする
    template(#cell(message)="row")
      .receive-message-row(@click="onDetail(row.item)")
        .d-flex.flex-row.mb-1
          // member name
          .flex-grow-1
            img.mr-2(v-show="!row.item.functionContents.isFinished" src="@/assets/sidemenu-sendmessage-incoming.png")
            span.member-name(v-if="row.item && row.item.functionContents && row.item.functionContents.hidden") 匿名
            span.member-name(v-else) {{ row.item.groupMemberName }}
          .datetime {{ getDisplayDate(row.item) }}
        .d-flex.flex-row.align-items-center
          .flex-grow-1
            // group name
            .mb-1(v-if="row.item && row.item.functionContents && row.item.functionContents.hidden")
              br
            .mb-1(v-else)
              span {{ row.item.groupTypeName }}
              span ・
              span {{ row.item.groupName}}
            // family last message
            .mb-1.last-message
              span {{ row.item.functionContents.content }}
          .buttons.svg-icon
            .angle-right
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 受信メッセージ(施設関係者)テーブルコンポーネント
 */
@Component({})
export default class OtherUserReceiveMessageTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<OtherUserReceiveMessageTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OtherUserReceiveMessageTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isBusy!: boolean;
  /** フィルター */
  @Prop()
  filter!: any;
  /** フィルター対象カラム */
  @Prop()
  filterFields!: string[];

  get _value(): Array<OtherUserReceiveMessageTableItem> {
    return this.value;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: OtherUserReceiveMessageTableItem): boolean {
    if (row.groupId == this.filter) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: Array<OtherUserReceiveMessageTableItem>) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 画面表示用の日付を返す
   */
  public getDisplayDate(message: OtherUserReceiveMessageTableItem): string {
    if (message.datetime) {
      return this.$dateUtil.convertNumberToString(Number(message.datetime), "mm月dd日 hh:MM");
    } else {
      return "";
    }
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  public onDetail(item: OtherUserReceiveMessageTableItem): void {
    this.$emit("onDetail", item);
    return;
  }
}

export interface OtherUserReceiveMessageTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

export interface OtherUserReceiveMessageTableItem {
  functionContents: { hidden: boolean; content: string; isFinished: boolean };
  groupMemberId: number;
  groupMemberName: string;
  groupName: string;
  groupTypeId: number;
  groupTypeName: string;
  datetime: number;
  groupId: number;
  otherUserOpinionMessagesCaseId: number;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/mobile/_mixin.scss";
@import "../../../styles/mobile/_colors.scss";

.other-user-receive-message-table-component {
  .svg-icon {
    width: 16px;
    height: 16px;
    margin-left: -6px;
    .angle-right {
      @include svg-icon("../../../assets/angle-right.svg", $font-base, 18px, 18px);
    }
  }

  .member-name {
    font-weight: bold;
  }
  .datetime {
    text-align: right;
    min-width: 8rem;
  }
  .last-message {
    // flexにした要素の中で省略「...」を出そうとするとブラウザのバグ？で省略されない
    // widthを指定することでバグを回避する
    // 全体の横幅から.buttons横幅、左右余白、.buttonsとメッセージの余白を減算する
    width: calc(100vw - 1rem - 1rem - 4rem - 1rem);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .buttons {
    .angle-right {
      color: $font-base;
    }
  }
}
</style>
